import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Imgix } from 'ha/modules/Image/Imgix';

const useStyles = makeStyles()({
  picture: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    objectPosition: 'center',
  },
});

interface Props {
  src: string;
}

// transparent pixel image is used to avoid showing gray image border box due to `img`' `src` attribute is empty or non existent.
const PLACEHOLDER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const Picture: React.FC<Props> = ({ src }) => {
  const { classes } = useStyles();

  return (
    <Imgix
      className={classes.picture}
      htmlAttributes={{ 'data-test-locator': 'gallery-image' }}
      imgixParams={{ fit: 'clip', cs: 'srgb' }}
      sizes="100vw"
      src={src || PLACEHOLDER_IMAGE}
    />
  );
};

export { Picture };
